import { Filter } from "react-table";
import { GridCoreState } from './types'
import {useState} from 'react'

export function useSessionStorage(key, props) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  let initialValue = {
    page: 0, 
    csv: false, 
    sort: props.sort !== undefined ? props.sort : "ASC",
    amount: props.amount !== undefined ? props.amount : 10, 
    field: props.defaultSortField, 
    filters: []
    }

  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.sessionStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };
  return [storedValue, setValue];
}

export const convertFilters = (grid: GridCoreState): Filter[] => {
  if (grid.filters.length > 0) {
    return grid.filters.map(filter => {
      return {
        id: filter.id,
        value: filter.value
      };
    });
  } else {
    return [];
  }
};
